// components

// actions
import ACTIONS from "../../constants/actions";
// others
import { AXIOS_INSTANCE } from "../../config.js";
import { LOCAL_STORAGE } from "../../constants/localStorageConstants";

const { SELECTED_BRANCH } = LOCAL_STORAGE;

const { GET_SHIFT_TYPES, GET_SHIFT_TYPES_SUCCESS, GET_SHIFT_TYPES_FAIL } =
  ACTIONS;

//get all shift types
export function getShiftTypes(pageData) {
  return (dispatch) => {
    dispatch({
      type: GET_SHIFT_TYPES,
    });
    return AXIOS_INSTANCE.request({
      method: "GET",
      url: `/api/${
        JSON.parse(localStorage.getItem(SELECTED_BRANCH))["code"]
      }/shiftTypes/`,
      params: pageData,
    })
      .then((res) => {
        dispatch({
          type: GET_SHIFT_TYPES_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_SHIFT_TYPES_FAIL,
        });
      });
  };
}
